import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchCurrentAccount } from '../../../../actions/currentAccount/currentAccountDetail'
import { AppState } from '../../../../reducers'
import { CurrentAccountDetailState } from '../../../../reducers/currentAccount/currentAccountDetail'
import { useTranslation } from 'react-i18next'
import { Paper, Box, Typography, Button, Stack } from '@mui/material';
import { KeyboardReturnOutlined } from '@mui/icons-material';
import moment from 'moment';
import { formattedCurrency } from '../../../../utils/StringUtils'
import { useThemeContext } from '../../../../theme/ThemeContext'

interface Props {
  currentAccountDetail: CurrentAccountDetailState
}

const CurrentAccountDetail: React.FC<Props> = ({ currentAccountDetail }) => {
  const dispatch = useDispatch()
  const params = useParams<{ currentAccountId: string, clientId?: string }>()
  const history = useHistory()
  const { t } = useTranslation(['current', 'others'])
  const { theme } = useThemeContext()

  useEffect(() => {
    dispatch(fetchCurrentAccount(params.currentAccountId, params.clientId, history.location.search))
  }, [dispatch, params.currentAccountId, params.clientId, history.location.search])

  const HeaderDetail: React.FC = () => {

    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        <Paper elevation={2}
          style={{
            padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
            textAlign: "justify", justifyContent: "space-around",
            borderRadius: "4px", margin: "4px"
          }}>
          {currentAccountDetail.currentAccountLines && currentAccountDetail.currentAccountLines.length > 0 &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('currentAccount')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{currentAccountDetail.currentAccountLines[0].comprobante}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('date')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{moment(currentAccountDetail.currentAccountLines[0].fecha).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('dueDate')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{moment(currentAccountDetail.currentAccountLines[0].vencimiento).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('total')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(currentAccountDetail.currentAccountLines.reduce((neto, currentAccount) => neto + Number(currentAccount.importe), 0))}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('total')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(currentAccountDetail.currentAccountLines[0].importe_moneda_original)}</Typography>
              </Box>
            </Box>}
        </Paper>
      </Paper>
    )
  }


  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100% - var(--header-height)' }}>
      <HeaderDetail />
      <Box display="flex" justifyContent="flex-start" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  currentAccountDetail: state.currentAccountDetail
})


export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(CurrentAccountDetail);